import Icon from './Icon';
import { SUPPORT_PHONE_TEL } from '../constants/site';

export default function PromoCards() {
  return (
    <section className="section section--warm">
      <div className="container">
        <div className="promo-grid">
          <article className="promo promo--a">
            <p className="promo__kicker">Complete Digital Security</p>
            <h3>Protection for every device you own</h3>
            <p>
              Laptops, phones, tablets, and smart TVs under one licence. Add a device in seconds
              from your account dashboard — no extra purchase required.
            </p>
            <div>
              <a href={`tel:${SUPPORT_PHONE_TEL}`} className="btn btn--light">
                <Icon name="phone" size={18} />
                Talk to a Specialist
              </a>
            </div>
          </article>

          <article className="promo promo--b">
            <p className="promo__kicker">Home &amp; Family</p>
            <h3>Keep the whole household safe online</h3>
            <p>
              Content filters, screen-time schedules, and location check-ins built for parents who
              want protection without constant arguments.
            </p>
            <div>
              <a href={`tel:${SUPPORT_PHONE_TEL}`} className="btn btn--light">
                <Icon name="family" size={18} />
                Set Up Family Safety
              </a>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
